// extracted by mini-css-extract-plugin
export default {"tab":"MessageTabList_tab__MhENE","icon":"MessageTabList_icon__G18IS","highlighted":"MessageTabList_highlighted__kzEey","withIndicator":"MessageTabList_withIndicator__xkFpu"};